var $1d2645d18d4c5be0$exports = {};
$1d2645d18d4c5be0$exports = {
  "calendar": "Calendrier",
  "day": "jour",
  "dayPeriod": "cadran",
  "endDate": "Date de fin",
  "era": "\xE8re",
  "hour": "heure",
  "minute": "minute",
  "month": "mois",
  "second": "seconde",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Date s\xE9lectionn\xE9e\xA0: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Plage s\xE9lectionn\xE9e\xA0: ".concat(args.startDate, " au ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Heure choisie\xA0: ".concat(args.time);
  },
  "startDate": "Date de d\xE9but",
  "timeZoneName": "fuseau horaire",
  "weekday": "jour de la semaine",
  "year": "ann\xE9e"
};
export { $1d2645d18d4c5be0$exports as default };